import React from 'react';
import { analytics } from 'Douleutaras/providers/analytics';
import classNames from 'classnames';
import MobilePromotionBanner from 'Douleutaras/layout/partials/MobilePromotionBanner';
import Snackbar from 'Douleutaras/components/Snackbar/Snackbar';

import DefaultFooter from './partials/DefaultFooter';
import DefaultHeader from './partials/DefaultHeader';
import MobileNavigationHeader from './partials/MobileNavigationHeader';
import './DefaultFullLayout.scss';

// Populate context
const contextDefault = { analytics }; // Add Analytics script (containing GTM)
export const MainContext = React.createContext(contextDefault);

export interface DefaultFullLayoutProps {
  children: React.ReactNode;
  noFooter?: boolean;
  noHeader?: boolean;
  innerScroll?: boolean;
  proHeader?: boolean; // Show Pro header
  headerOptions?: HeaderOptionsProps;
}

export interface HeaderOptionsProps {
  showBackButton: boolean;
  goBackLink: string; // relative or full url
  goBackLinkTitle?: string;
}

const defaultHeaderOptions = {
  showBackButton: false, // Should we show the back navigation button on mobile?
  goBackLink: '#' // Link of the back button
};

const DefaultFullLayout =
  ({ children,
     noFooter = false,
     noHeader = false,
     innerScroll = false,
     proHeader = false,
     headerOptions = defaultHeaderOptions
  }: DefaultFullLayoutProps) => {

  return (
    <MainContext.Provider value={contextDefault}>
      <div styleName="default-layout-wrapper">
        { !noHeader &&
          <DefaultHeader showProHeader={proHeader} />
        }
        {
          headerOptions.showBackButton && <MobileNavigationHeader goBackLink={headerOptions.goBackLink} />
        }
        <main styleName={classNames({
                          'dashboard-main': true,
                          'dashboard-main--scrollable': innerScroll
                        })}>
          {children}
        </main>
        { !noFooter &&
          <DefaultFooter />
        }
      </div>
      <MobilePromotionBanner />
      <Snackbar />
    </MainContext.Provider>
  );
};

export default DefaultFullLayout;
